import { render, staticRenderFns } from "./DashboardMaturation.vue?vue&type=template&id=597480e6"
import script from "./DashboardMaturation.vue?vue&type=script&lang=js"
export * from "./DashboardMaturation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports